<template>
  <div>
    <v-row>
      <v-col cols='12'>
        <v-text-field
          label='Address'
          v-model='value.address'
        ></v-text-field>
      </v-col>
      <v-col cols='12' md='8'>
        <v-text-field
          label='City'
          v-model='value.city'
        ></v-text-field>
      </v-col>
      <v-col cols='12' md='4'>
        <v-text-field
          label='Province'
          v-model='value.province'
        ></v-text-field>
      </v-col>
      <v-col cols='12' md='8'>
        <v-text-field
          label='Country'
          v-model='value.country'
        ></v-text-field>
      </v-col>
      <v-col cols='12' md='4'>
        <wc-postal-code-input 
          v-model='value.postal_code'
        ></wc-postal-code-input>
      </v-col>
      <v-col cols='12' md='6'>
        <v-text-field
          label='Phone'
          v-model='value.phone'
          prepend-icon='mdi-phone'
        ></v-text-field>
      </v-col>
      <v-col cols='12' md='6'>
        <v-text-field
          label='Website'
          v-model='value.website'
          prepend-icon='mdi-firefox'
        ></v-text-field>
      </v-col>
      <v-col cols='12'>
        <v-text-field
          label='Accounts receivable email'
          v-model='value.ar_email'
          prepend-icon='mdi-email'
          :rules='[rules.email]'
        ></v-text-field>
      </v-col>
    </v-row>
  </div>
</template>

<script>
import formRules from '@/mixins/formRules';
import WCPostalCodeInput from '@/components/forms/WCPostalCodeInput';

export default {
  name: 'division-contact-details-form',
  mixins: [formRules],
  props: {
    value: {
      required: true
    }
  },
  components: {
    'wc-postal-code-input': WCPostalCodeInput
  }
}
</script>
